<template>
    <v-row>
        <v-col cols="12" class="justify-content-start d-flex px-8 pt-6 pb-4">
            <v-btn rounded text color="primary" @click="cancelAction">
                {{ t('patients::button.cancel') }}
            </v-btn>
            <v-btn
                v-if="!saveBtnDisabled && saveAllowed"
                color="primary"
                rounded
                class="ml-4"
                :loading="patientsFormLoading"
                @click="savePatient()"
            >
                {{ isAdmin ? t('patients::button.save') : t('patients::button.send_save_request') }}
            </v-btn>

            <v-tooltip v-else-if="saveAllowed" top>
                <template #activator="{ on }">
                    <div v-on="on">
                        <v-btn color="primary" rounded class="ml-4" :loading="patientsFormLoading" disabled>
                            {{ isAdmin ? t('patients::button.save') : t('patients::button.send_save_request') }}
                        </v-btn>
                    </div>
                </template>
                <span>{{ t('patients::tooltip.request_already_sent') }}</span>
            </v-tooltip>
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: {
        showAdditionalButtons: {
            type: Boolean,
            required: false,
            default: false,
        },
        saveBtnDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            patientsFormLoading: false,
        };
    },
    computed: {
        id() {
            return this.$store.state.patients.patient.id;
        },
        isAdmin() {
            return User.group === 'admins';
        },
        saveAllowed() {
            return this.can('api.v1.patients.update') || this.can('api.v1.patients.store');
        },
    },
    methods: {
        savePatient() {
            this.patientsFormLoading = true;
            this.$store.dispatch('patients/resetErrorMessages');
            const data = this.prepareData();
            return axios({
                method: this.id ? 'put' : 'post',
                url: this.id ? route('api.v1.patients.update', { patient: this.id }) : route('api.v1.patients.store'),
                data,
            })
                .then((response) => {
                    if (!response) {
                        return;
                    }
                    const newPatient = response.data.data;
                    const data = { item: 'patient', data: false };
                    this.$root.setLocalStorage(data, 'remove');
                    if (!this.id) {
                        if (this.isAdmin) {
                            this.$root.notify('info', t('patients::notification.patient.created'));
                        } else {
                            this.$root.notify('info', t('patients::notification.patient.send_approval'));
                            this.$emit('disable-save-btn');
                        }

                        return this.$root.goTo(route('patients.preview', { id: newPatient.id }));
                    }

                    if (!this.isAdmin) {
                        this.$root.notify('info', t('patients::notification.patient.send_approval'));
                        this.$emit('disable-save-btn');
                        return this.$root.goTo(route('patients.preview', { id: newPatient.id }));
                    }

                    this.$root.notify('info', t('patients::notification.patient.update'));
                    this.$store.dispatch('patients/reloadPatientData');
                })
                .catch((error) => {
                    if (error.response && error.response.status === 422) {
                        this.$store.dispatch('patients/setErrorMessages', error.response.data.errors);
                        this.$root.parseErrorsAndNotify(error);

                        if (this.$store.state.patients.errorMessages.patient.id.length) {
                            this.$root.notify('error', this.$store.state.patients.errorMessages.patient.id[0]);
                        }
                    } else {
                        if (error && error.response) {
                            this.$root.notify('error', error.response.data.error);
                        } else {
                            this.$root.notify('error', t('default::notification.error'));
                        }
                    }
                })
                .finally(() => _.delay(() => (this.patientsFormLoading = false), 400));
        },
        cancelAction() {
            return this.$root.goTo(route('patients.preview', { id: this.id }));
        },
        prepareData() {
            const data = _.clone(this.$store.state.patients.patient);
            const fieldsToRemove = ['dispensing', 'pharmacy_site', 'consultant'];

            if (data) {
                Object.keys(data).forEach((key) => {
                    if (fieldsToRemove.includes(key)) {
                        delete data[key];
                    }
                });
            }

            return data;
        },
    },
};
</script>

<style></style>
